import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { Modal, Button, Tooltip } from "antd";

import { sendNotification, handleSetSrc } from "../../utils";
import {
  buildEmbedSnippet,
  buildGalleryEmbedPath,
  MAX_EMBED_GALLERY_ASSETS
} from "../bunkey-host/embedSnippet";
import { resolveMedia } from "../bunkey-host-embed/embedMedia";

// Un asset entra a la galería solo si el embed público sabe pintarlo; si no,
// el visitante vería el placeholder de "no se puede previsualizar".
const isEmbeddable = asset =>
  !!asset && resolveMedia(asset, "media").kind !== "unsupported";

export class MultiBunkeyHostModal extends Component {
  copyGallery = quality => {
    const { intl, selectedFiles, handleHiddenModal } = this.props;

    const usable = (selectedFiles || []).filter(isEmbeddable);
    const ids = usable
      .slice(0, MAX_EMBED_GALLERY_ASSETS)
      .map(asset => asset._id);

    if (!ids.length) return;

    const title = usable
      .slice(0, MAX_EMBED_GALLERY_ASSETS)
      .map(asset => asset.name)
      .join(", ")
      .replace(/"/g, "'"); // el title va dentro de comillas dobles en el iframe

    navigator.clipboard.writeText(
      buildEmbedSnippet(buildGalleryEmbedPath(ids, quality), title)
    );
    sendNotification("success", intl, intl.formatMessage({ id: "link_copied" }));
    handleHiddenModal();
  };

  render() {
    const { intl, showModal, handleHiddenModal, selectedFiles } = this.props;

    const all = selectedFiles || [];
    const usable = all.filter(isEmbeddable);
    const included = usable.slice(0, MAX_EMBED_GALLERY_ASSETS);
    const excluded = all.length - included.length;

    return (
      <Modal
        visible={showModal}
        title={intl.formatMessage({ id: "insert_gallery_bunkey_host" })}
        onCancel={handleHiddenModal}
        destroyOnClose
        footer={null}
      >
        <p className="important-message-style">
          {intl.formatMessage(
            { id: "insert_gallery_help" },
            { max: MAX_EMBED_GALLERY_ASSETS }
          )}
        </p>

        <div className="bk-gallery-preview">
          {included.map((asset, i) => (
            <div className="bk-gallery-preview__item" key={asset._id}>
              <Tooltip title={asset.name}>
                <img src={handleSetSrc(asset)} alt={asset.name} />
              </Tooltip>
              <span className="bk-gallery-preview__pos">{i + 1}</span>
            </div>
          ))}
        </div>

        {excluded > 0 && (
          <p className="important-message-style">
            {intl.formatMessage({ id: "insert_gallery_excluded" }, { excluded })}
          </p>
        )}

        <div className="grapper-button">
          <Button
            className="copy-button"
            disabled={!included.length}
            onClick={() => this.copyGallery("original")}
          >
            {intl.formatMessage({ id: "copy_original_url" })}
          </Button>
          <Button
            className="copy-button"
            disabled={!included.length}
            onClick={() => this.copyGallery("media")}
          >
            {intl.formatMessage({ id: "copy_optimized_url" })}
          </Button>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  selectedFiles: state.selectedFiles.data
});

export default injectIntl(connect(mapStateToProps)(MultiBunkeyHostModal));
